export default "__VITE_ASSET__dFReOToo__"